import NotificationPart from "localization/base/pages/rdevNotifications/NotificationPart";

const notificationMessage: NotificationPart = {
  internetOutage: `Internetausfall zwischen '{from}' und '{to}'. `,
  osVersionChanged: `Betriebssystemversion von '{oldVersion}' auf '{newVersion}' geändert.`,
  rdevVersionChanged: `RDev version von '{oldVersion}' in '{newVersion}' geändert.`
};

export default notificationMessage;
